<template>
  <div class="vehicle">
    <table v-if="isEmpty || isLoading">
      <thead>
        <tr>
          <th v-for="(header, index) in data.header" :key="index">{{header}}</th>
        </tr>
      </thead>
      <tbody class="loading" v-if="!isEmpty">
        <tr >
          <td :colspan="data.header.length">
            <adx-loading-primary />
          </td>
        </tr>
      </tbody>
      <tbody class="empty" v-if="!isLoading">
        <tr >
          <td :colspan="data.header.length">
            <div class="emptyState">
              <h4>Nothing to show right now</h4>
              <p class="small-font">Please modify your filter or change your search</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <adx-list-item v-else :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'
import LoadingPrimary from '@/components/Loading/Primary'
import EmptySelection from '@/components/NotFound/Selection'

import formatMoney from 'accounting-js/lib/formatMoney.js'
import lib from '@/lib/util'
import moment from 'moment'
import axios from 'axios'
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-campaignreport-demographic-age',
  components: {
    'adx-list-item': ListItem,
    'adx-loading-primary': LoadingPrimary,
    'adx-empty-selection': EmptySelection
  },
  props: {
    start_date: {
      type: String,
      required: false
    },
    end_date: {
      type: String,
      required: false
    },
    idParent: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      data: {
        header: ['VEHICLE ID', 'ROUTES', 'AVG. KM', 'TOTAL KM'],
        body: []
      },
      report : [],
      isEmpty: false,
      isLoading : true
    }
  },
  computed: {
    // isLoading: function(){
    //   return this.$apollo.loading || false
    // },
  },
  watch: {

  },
  // apollo: {
  //   busMeasurementReport: {
  //     query: require('@/graphql/bus/measurementReport.gql'),
  //     loadingKey: 'loading',
  //     variables(){
  //       return {
  //         id: this.idParent,
  //       }
  //     },
  //     result(data) {
  //       if (this.data.body.length == 0) {
  //         const { busMeasurementReport } = data.data
  //         if (busMeasurementReport){
  //           this.filterDate(busMeasurementReport)
  //           this.loadData()
  //         }
  //       }
  //     }
  //   },
  // },
  beforeCreate() {

  },
  created() {
  },
  beforeMount() {

  },
  mounted() {
    this.busReport()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async busReport(){
      // this.isLoading = true
      // const res = await this.$apollo.query({
      //   query: require('@/graphql/bus/measurementReport.gql'),
      //   loadingKey:'loading',
      //   errorPolicy:'all',
      //   fetchPolicy:'network-only',
      //   variables:{
      //     id: this.idParent
      //   }
      // })
      // if (res.data){
      //   const { busMeasurementReport } = res.data
      //   if (busMeasurementReport){
      //     this.filterDate(busMeasurementReport)
      //   }
      // }

      // const { data } = await axios.get(`http://128.199.135.58:3001/measurement-report/${this.idParent}/api/`, { headers: {'Authorization': this.$store.getters.token, 'owner': this.$store.getters.userId} })

      const { data } = await api.get(apiV2.busMeasurement(this.idParent), { needToken: true })

      this.filterDate(data)
    },
    async filterDate(busMeasurementReport){
      let data = busMeasurementReport
      let campaign = data.busOrder.campaign
      let start = new Date(this.start_date)
      let end = new Date(this.end_date)
      let filtered = null
      let measurement = data.measurement

      if (data){
        filtered = measurement.filter(m => {
          let markerDate = moment(m.measurementId.date).format('YYYY-MM-DD')
          let startFormated = moment(start).format('YYYY-MM-DD')
          let endFormated = moment(end).format('YYYY-MM-DD')
          return markerDate >= startFormated && markerDate <= endFormated
        });
      }
      this.report = filtered
      await this.loadData()
      this.isLoading = false
    },
    getFormatNumber(value){
      return formatMoney(value, { symbol: ``, precision: 0, thousand: `.` })
    },
    async loadData() {
      let temp = []
      let result = []
      let data = this.report
      let measurement = data

      measurement.forEach(m => {
        let vehicle = m.measurementId.vehicleId 
        let route = m.routeId.title
        let distance = m.measurementId.distance
        temp.push({
          vehicle: vehicle ,
          route: route,
          distance: distance,
        })

        result.push(vehicle)
      })

      result = [...new Set(result)]
      result.forEach(res => {
        let filteredMeasurement = temp.filter(obj => obj.vehicle == res)
        let bus = filteredMeasurement.length
        let distance = filteredMeasurement.reduce((total, current) => total + current.distance, 0)
        let data = filteredMeasurement.shift()
        let avg_km = bus ? this.getFormatNumber(Math.round(distance/bus)) : 0
        let total_km = distance ? this.getFormatNumber(Math.round(distance)) : 0

        this.data.body.push({
          vehicle: data.vehicle,
          route: data.route,
          avg: avg_km,
          total: total_km,
        })
      })

      if (!result.length) this.isEmpty = true
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
.busReport{
  &__report{
    &__content{
      .vehicle{
        .listDemographic{
          table{
            thead{
              tr {
                th {
                  font-size: 12px
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>